import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-privacy-notice",
  templateUrl: "./privacy-notice.component.html",
  styleUrls: ["./privacy-notice.component.scss"],
})
export class PrivacyNoticeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/privacy-notice/privacy-notice.component.ts